import { render, staticRenderFns } from "./DynamicSp.vue?vue&type=template&id=28bbdf03&scoped=true"
import script from "./DynamicSp.vue?vue&type=script&lang=js"
export * from "./DynamicSp.vue?vue&type=script&lang=js"
import style0 from "./DynamicSp.vue?vue&type=style&index=0&id=28bbdf03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bbdf03",
  null
  
)

export default component.exports